var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rests_times" },
    [_c("times", { attrs: { times: this.rest.times } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }